// components/CommunitySection.jsx
import React from "react";
import "./CommunitySection.css";

import WifiRoundedIcon from "@mui/icons-material/WifiRounded";
import VolunteerActivismRoundedIcon from "@mui/icons-material/VolunteerActivismRounded";
import ExploreRoundedIcon from "@mui/icons-material/ExploreRounded";

function CommunitySection() {
  return (
    <section className="community-section" id="community">
      <div className="community-inner">
        {/* Header */}
        <div className="community-header">
          {/* <p className="community-kicker">Community</p> */}
          <h2 className="community-title">Community that travels with you</h2>
          <p className="community-subtitle">
            Tawaf isn&apos;t just an app you use alone; it&apos;s a community you
            journey with, helping you stay connected in real time and learn from
            fellow pilgrims around the world.
          </p>
        </div>

        {/* 3-column content */}
        <div className="community-grid">
          <article className="community-item">
            <div className="community-icon">
              <WifiRoundedIcon fontSize="medium" />
            </div>
            <h3 className="community-item-title">
              Stay connected in real time
            </h3>
            <p className="community-item-body">
              Join your group, share locations, and use in-app chat and calls to
              stay together in the crowd.
            </p>
          </article>

          <article className="community-item">
            <div className="community-icon">
              <VolunteerActivismRoundedIcon fontSize="medium" />
            </div>
            <h3 className="community-item-title">
              Share experiences and advice
            </h3>
            <p className="community-item-body">
              Ask questions, share reflections, and learn from others in
              focused, pilgrimage-centered spaces.
            </p>
          </article>

          <article className="community-item">
            <div className="community-icon">
              <ExploreRoundedIcon fontSize="medium" />
            </div>
            <h3 className="community-item-title">
              Discover tips and recommendations
            </h3>
            <p className="community-item-body">
              Find practical, experience-based guidance on where to go, how to
              move, and what to expect.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}

export default CommunitySection;
